import { render, staticRenderFns } from "./ModalChangeAward.vue?vue&type=template&id=69056164&"
import script from "./ModalChangeAward.vue?vue&type=script&lang=js&"
export * from "./ModalChangeAward.vue?vue&type=script&lang=js&"
import style0 from "./ModalChangeAward.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports